import QRCode from 'react-qr-code';
import RolesSCP from '../../../../../../../Services/Data/SCP/RolesSCP';
import './RequestData.css';

const RequestData = ({getSelectedPlayers}) => {
    const player = getSelectedPlayers()[0];

    const playerRole = player ? RolesSCP[player.playerRoleId + 1] : null;

    return (
        <>
            <h3 className="text-center">Select a player from the list and choose the appropriate button to retrieve data.</h3>

            { player &&
                <>
                    <div className="flex">
                        <div className="qrCodeContainer">
                            <QRCode value={"User Id: " + player.userId} size={"15vh"}/>
                        </div>
                    </div>
                    <div className="requestDataRow">
                        <p className='requestDataRowFirst'>Nickname</p>
                        <p>{player.nickname}</p>
                    </div>
                    <div className="requestDataRow">
                        <p className='requestDataRowFirst'>In-Game Id</p>
                        <p>{player.inGameId}</p>
                    </div>
                    <div className="requestDataRow">
                        <p className='requestDataRowFirst'>IP Address</p>
                        <p>**********</p>
                    </div>
                    <div className="requestDataRow">
                        <p className='requestDataRowFirst'>User ID</p>
                        <p>{player.userId}</p>
                    </div>
                    <div className="requestDataRow">
                        <p className='requestDataRowFirst'>Rank</p>
                        <p style={{color: player.rankColor}}>{player.rankName}</p>
                    </div>

                    { playerRole &&
                        <div className="requestDataRow">
                            <p className='requestDataRowFirst'>Role</p>
                            <p style={{color: playerRole.color}}>{playerRole.name}</p>
                        </div>
                    }
                </>
            }
        </>
    )
}

export default RequestData;